import { useState } from "react"
import { useEffect } from "react"
import { Modal, Table, Button } from "antd";
import { request, requestkind } from '../unit/request'


const CreditSummary = (props: { partnerNumber: string }) => {
    const [summary, setSummary] = useState<any[]>([])
    const [source, setSource] = useState<any[]>([])
    const [is_show_info, set_is_show_info] = useState<boolean>(false)
    const getCurrentParterInfo = async () => {
        console.log('getting...')
        const json = await request(null, null, requestkind.Partner.CurrentParterInfo)
        const { PartnerNumber, PartnerName } = json.Data
        console.log(json, PartnerNumber, PartnerName)
        return PartnerNumber
    }
    const getinfo = async () => {
        const p = await getCurrentParterInfo()
        // console.log('p', p)
        const res = await request({
            partnerNumber: p
        }, null, requestkind.Credit.GetPartnerOverdueDetail)
        console.log(res.Data)
        setSource(res.Data)
        set_is_show_info(true)
    }
    useEffect(() => {
        (async () => {
            const json = await request(null, {
                partnerNumber: props.partnerNumber
            }, requestkind.Credit.GetCreditSummary)

            console.log('getCreditSummary', json)
            const obj = json.Data
            obj['key'] = 0
            if (obj.OverdueAmount > 0) {
                console.log('贵司目前存在逾期欠款，请及时付款！')
                Modal.warning({
                    title: '警告',
                    content: "贵司目前存在逾期欠款，请及时付款！"
                })
            }
            const arr = [obj]
            setSummary(arr)
        })()
    }, [])
    return (
        <div>
            <Modal width="90%" title="逾期明细" visible={is_show_info} onOk={() => {
                set_is_show_info(false)
            }} onCancel={() => {
                set_is_show_info(false)
            }}>
                <Table pagination={false} columns={[
                    {
                        title: "客户名称",
                        key: "EndCustomerName",
                        dataIndex: "EndCustomerName"
                    },
                    {
                        title: "合约编号",
                        key: "AgreementNumber",
                        dataIndex: "AgreementNumber"
                    },
                    {
                        title: "金额（含税）",
                        key: "Amount",
                        dataIndex: "Amount",
                        render: (amount: number) => {
                            return (
                                <span>{amount.toLocaleString()}</span>
                            )
                        }
                    },
                    {
                        title: "到期日",
                        key: "DueDate",
                        dataIndex: "DueDate",
                        render: (date: string) => {
                            return (
                                <span>{date.split(' ')[0]}</span>
                            )
                        }
                    },

                ]} dataSource={source} />
            </Modal>

            <Table pagination={false} columns={[
                {
                    title: "可用额度",
                    key: "AvailableAmount",
                    dataIndex: "AvailableAmount",
                    render: (amount: number) => {
                        return (
                            <span>{summary[0].IsUnlimited ? '无上限' : amount.toLocaleString()}</span>
                        )
                    }
                },
                {
                    title: "信用额度",
                    key: "GuaranteeTotalAmount",
                    dataIndex: "GuaranteeTotalAmount",
                    render: (amount: number) => {
                        return (
                            <span>{amount.toLocaleString()}</span>
                        )
                    }
                },
                {
                    title: "逾期金额",
                    key: "OverdueAmount",
                    dataIndex: "OverdueAmount",
                    render: (amount: number) => {
                        if (amount !== 0) {
                            if (amount > 0) {
                                return (
                                    <div>
                                        <span style={{
                                            color: amount > 0 ? "#f00" : "#000"
                                        }}>{amount.toLocaleString()}</span>&nbsp;<Button size="small" onClick={getinfo}>查看详细</Button></div>
                                )

                            } else {
                                return (
                                    <div><span>{amount.toLocaleString()}</span>&nbsp;<Button size="small" onClick={getinfo}>查看详细</Button></div>
                                )

                            }
                        } else {
                            return (
                                <span>{amount.toLocaleString()}</span>
                            )
                        }
                    }
                },
                {
                    title: "账期内欠款",
                    key: "PayableAmount",
                    dataIndex: "PayableAmount",
                    render: (amount: number) => {
                        return (
                            <span>{amount.toLocaleString()}</span>
                        )
                    }
                },
                {
                    title: "未来账单金额",
                    key: "FutureHighestAmount",
                    dataIndex: "FutureHighestAmount",
                    render: (amount: number) => {
                        return (
                            <span>{amount.toLocaleString()}</span>
                        )
                    }
                },

            ]} dataSource={summary} /></div>
    )
}



const GuaranteeSummary = (props: { partnerNumber: string }) => {
    const [summary, setSummary] = useState<any>([])

    useEffect(() => {
        (async () => {
            const json = await request(null, {
                partnerNumber: props.partnerNumber
            }, requestkind.Credit.GetGuaranteeSummary)
            console.log('getGuaranteeSummary', json)
            const obj = json.Data
            obj['key'] = 0
            const arr = [obj]
            setSummary(arr)
        })()
    }, [])
    return (
        <Table pagination={false} columns={[
            // {
            //     title: "担保总额度",
            //     key: "GuaranteeTotalAmount",
            //     dataIndex: "GuaranteeTotalAmount",
            // },
            {
                title: "保证金额度",
                key: "SecurityDepositAmount",
                dataIndex: "SecurityDepositAmount",
                render: (amount: number) => {
                    return (
                        <span>{amount.toLocaleString()}</span>
                    )
                }
            },
            {
                title: "有效银行保函额度",
                key: "ValidBankGuaranteeAmount",
                dataIndex: "ValidBankGuaranteeAmount",
                render: (amount: number) => {
                    return (
                        <span>{amount.toLocaleString()}</span>
                    )
                }
            },
            {
                title: "有效公司保函额度",
                key: "ValidCorpGuaranteeAmount",
                dataIndex: "ValidCorpGuaranteeAmount",
                render: (amount: number) => {
                    return (
                        <span>{amount.toLocaleString()}</span>
                    )
                }
            },
            {
                title: "无效银行保函额度",
                key: "InvalidBankGuaranteeAmount",
                dataIndex: "InvalidBankGuaranteeAmount",
                render: (amount: number) => {
                    return (
                        <span>{amount.toLocaleString()}</span>
                    )
                }
            },
            {
                title: "无效公司保函额度",
                key: "InvalidCorpGuaranteeAmount",
                dataIndex: "InvalidCorpGuaranteeAmount",
                render: (amount: number) => {
                    return (
                        <span>{amount.toLocaleString()}</span>
                    )
                }
            }
        ]} dataSource={summary} />
    )
}

export { CreditSummary, GuaranteeSummary }